import { FC, useContext, useState } from "react"

import Modal from "../modal";

import { CustomButtonRightProps } from "./types";
import { PracticeProps } from "src/pages/manufacturer/types";
import { Link } from "react-router-dom";
import { AuthContext } from "src/context/authContext";


const CustomButtonRight: FC<CustomButtonRightProps> = ({ statisticsObject }): JSX.Element => {
  const [showingModal, setModal] = useState(false);
  const [title, setTitle] = useState("");
  const {userData} = useContext(AuthContext);
  const openModal = (title: string) => {
    setTitle(title);
    setModal(true);
    document.body.style.overflow = 'hidden';
  };

  return (
      <>
        {showingModal ? <Modal title={title}
          data={(statisticsObject && statisticsObject.new_practices && statisticsObject.new_practices.data as PracticeProps[])}
          onClick={() => setModal(false)}></Modal> : null}

       {userData?.ref_type === "Manufacturer" && (
         <div className="card" style={{height: 150}}>
           <div className="card-header text-center">
             <h4 className="mb-0">Outside 72Hr
             </h4>
           </div>
           <div className="card-body text-center">
            <Link
                to=""
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                className="mt-2 mb-0 fw-normal fs-6 text-secondary"
                title={
                    statisticsObject && statisticsObject.outside_72hr
                      ? statisticsObject.outside_72hr.cases_id && statisticsObject.outside_72hr.cases_id.map(item => item).join(", ")
                      : "No cases available"
                }
            >
              <h1 className="fw-bold text-center fw-bold m-0">
                {statisticsObject && statisticsObject.outside_72hr ? statisticsObject.outside_72hr.total_count : 0}
              </h1>
            </Link>


          </div>
        </div>)}

        <div className="card col mt-3" style={{minHeight: 150}}>
          <div className="card-header text-center">
            <h4 className="mb-0 text-center">Avg TAT</h4>
          </div>
          <div className="card-body text-center">
            <p className="fs-1 text-black fw-bold text-center fw-bold m-0 h-100 align-bottom lh-lg">
              {statisticsObject ? statisticsObject.avg_tat : "00:00:00"}
            </p>
          </div>
        </div>

        <div className="card col mt-3" style={{minHeight: 150}}>
          <div className="card-header text-center">
            <h4 className="mb-0 text-center">New Practices</h4>
          </div>
          <div className="card-body text-center" onClick={() => {
            openModal("New Practices")
          }}>
            <p className="fs-1 text-link fw-bold link-modal text-center fw-bold m-0 lh-lg">
              {statisticsObject.new_practices.count}
            </p>
          </div>
        </div>
      </>
  )
}
export default CustomButtonRight;
